import { useCompanies } from "hooks/useCompanies";
import { useUser } from "hooks/useUser";
import { useCompanyStore } from "store/company.store";

/**
 * The company the sidebar's company picker shows: the stored choice, else the
 * user's last company, else their first. Both sidebar menus read it, so they
 * agree on which company the Company Projects row stands for (EQ-2488).
 */
export function useSidebarCompanyId(): number | null {
	const { data } = useCompanies();
	const { user } = useUser();
	return (
		useCompanyStore((state) => state.id) ??
		user?.lastCompany?.id ??
		data?.[0]?.id ??
		null
	);
}
